// removed by extract-text-webpack-plugin
module.exports = {"footer":"SwitchLanguage__footer___2gHS-","switch-language":"SwitchLanguage__switch-language___1ETg-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Main/SwitchLanguage/SwitchLanguage.scss
// module id = 927
// module chunks = 0